<template>
  <div class="declaration-scope">
    <div style="display: flex;">
      <div class="show-right section" style="width: 60%;background-color: #FFFFFF;">
        <div class="main-content left" style="margin-left: 20px;margin-bottom: 50px;">
          <el-form :inline="true" :disabled="useHqSet" label-width="100px" label-position="left">
            <div class="el-form-item-wrapper" style="margin-top: 10px;">
              <el-form-item>
                <span class="title" style="font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.Cargo_DeclarationBusiness') }}</span>
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.fcl" no="fcl" :disabled="!isEdit" @change="uncheckClearValue(form.fcl, 'fclArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_FCL') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  :disabled="!(isEdit && form.fcl)"
                  :placeholder="' '"
                  filterable
                  :static-options="eqSizeType"
                  :default-multiple-value="form.fclArray"
                  :multiple="true"
                  :cache="false"
                  tag-name="code"
                  tag-value="value"
                  :filter-tag-names="['code']"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.fclArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.selfPickup" no="selfPickup" :disabled="!isEdit" @change="uncheckClearValue(form.selfPickup, 'selfPickupArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_CustomerSpace3') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="selfPickupValue"
                  :disabled="!(isEdit && form.selfPickup)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_IncoTerm"
                  filterable
                  :clearable="true"
                  :default-multiple-value="form.selfPickupArray"
                  style="width: 350px;"
                  :multiple="true"
                  @parentCallBack="p=>{form.selfPickupArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.designatedGoods" no="designatedGoods" :disabled="!isEdit" @change="uncheckClearValue(form.designatedGoods, 'designatedGoodsArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_CustomerSpace2') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="designatedGoodsValue"
                  :disabled="!(isEdit && form.designatedGoods)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_IncoTerm"
                  filterable
                  :clearable="true"
                  :default-multiple-value="form.designatedGoodsArray"
                  :multiple="true"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.designatedGoodsArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.pol" no="pol" :disabled="!isEdit" @change="uncheckClearValue(form.pol, 'loadingPortCodeArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_PortOfLoading') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="loadingPortCode"
                  :disabled="!(isEdit && form.pol)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-multiple-value="form.loadingPortCodeArray"
                  :custom-label="(item)=>`${item.code}`"
                  :multiple="true"
                  style="flex:1;width: 350px;"
                  @parentCallBack="p=>{form.loadingPortCodeArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.pod" no="pod" :disabled="!isEdit" @change="uncheckClearValue(form.pod, 'dischargingPortCodeArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_PlaceOfDelivery') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="dischargingPortCode"
                  :disabled="!(isEdit && form.pod)"
                  :placeholder="' '"
                  :static-options="pods"
                  filterable
                  :default-multiple-value="form.dischargingPortCodeArray"
                  :multiple="true"
                  tag-name="code"
                  tag-value="value"
                  :custom-label="(item)=>`${item.code}`"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.dischargingPortCodeArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.customJob" no="ri" :disabled="!isEdit" @change="uncheckClearValue(form.customJob, 'customJobTypeArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_CustomJobType') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="customJobType"
                  :disabled="!(isEdit && form.customJob)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_CutomJobType"
                  :method-params="{active: true}"
                  :clearable="true"
                  filterable
                  :default-multiple-value="form.customJobTypeArray"
                  :custom-label="(item)=>`[${item.code}]${isZh ? item.name : item.englishName}[${item.type}]${item.containerLoadType}`"
                  tag-value="uuid"
                  :multiple="true"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.customJobTypeArray = p.value}"
                />
              </el-form-item>
            </div>

            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.cargoType" no="ri" :disabled="!isEdit" @change="uncheckClearValue(form.cargoType, 'cargoTypeArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_CargoType') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="cargoType"
                  :disabled="!(isEdit && form.cargoType)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_CargoType"
                  :method-params="{sea: true}"
                  :clearable="true"
                  filterable
                  :default-multiple-value="form.cargoTypeArray"
                  :multiple="true"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.cargoTypeArray = p.value}"
                />
              </el-form-item>
            </div>

            <!-- 申报费用 -->
            <div class="el-form-item-wrapper" style="margin-top: 20px;">
              <el-form-item>
                <span class="title" style="font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.Cargo_DeclarationFee') }}</span>
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.price" no="price" :disabled="true" @change="uncheckClearValue(form.price, 'priceArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_FreightRate') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  filterable
                  no="price"
                  :disabled="!(isEdit && form.price)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :clearable="true"
                  :default-multiple-value="form.priceArray"
                  :multiple="true"
                  callback-method-type="value"
                  style="width: 350px;"
                  tag-value="itemId"
                  tag-name="zhName"
                  :custom-label="(item)=>`[${item.chargecode}]${isZh ? item.zhName : item.enName}`"
                  @parentCallBack="p=>{form.priceArray = p}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item style="margin-left: 20px;">
                {{ $t('CargoMsg.Cargo_LowerLimit') + ' = ' + $t('CargoMsg.Cargo_FreightRate') }}
                <el-select v-model="form.lowerOperators" :disabled="!isEdit" no="lowerOperators" style="width: 50px;margin: 0 5px 0 5px;" placeholder="">
                  <el-option
                    v-for="value in numOperators"
                    :key="value"
                    :label="value"
                    :value="value"
                  />
                </el-select>
                <el-input-number v-model="form.lowerNum" :disabled="!isEdit" :controls="false" style="width: 70px;" :precision="0" :min="0" :max="999999999" />
              </el-form-item>
              <el-form-item style="margin-left: 20px;">
                {{ $t('CargoMsg.Cargo_UpperLimit') + ' = ' + $t('CargoMsg.Cargo_FreightRate') }}
                <el-select v-model="form.upperOperators" :disabled="!isEdit" no="upperOperators" style="width: 50px;margin: 0 5px 0 5px;" placeholder="">
                  <el-option
                    v-for="value in numOperators"
                    :key="value"
                    :label="value"
                    :value="value"
                  />
                </el-select>
                <el-input-number v-model="form.upperNum" :disabled="!isEdit" :controls="false" style="width: 70px;" :precision="0" :min="0" :max="999999999" />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.commission" no="commission" :disabled="!isEdit" @change="uncheckClearValue(form.commission, 'commissionArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_Commission') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  filterable
                  no="commissionArray"
                  :disabled="!(isEdit && form.commission)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :clearable="true"
                  :default-multiple-value="form.commissionArray"
                  :multiple="true"
                  callback-method-type="value"
                  style="width: 350px;"
                  tag-value="itemId"
                  tag-name="zhName"
                  :custom-label="(item)=>`[${item.chargecode}]${isZh ? item.zhName : item.enName}`"
                  @parentCallBack="p=>{form.commissionArray = p}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.containerLock" no="containerLock" :disabled="!isEdit" @change="uncheckClearValue(form.containerLock, 'containerLockArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_ContainerLock') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  filterable
                  no="containerLockArray"
                  :disabled="!(isEdit && form.containerLock)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :clearable="true"
                  :default-multiple-value="form.containerLockArray"
                  :multiple="true"
                  callback-method-type="value"
                  style="width: 350px;"
                  tag-value="itemId"
                  tag-name="zhName"
                  :custom-label="(item)=>`[${item.chargecode}]${isZh ? item.zhName : item.enName}`"
                  @parentCallBack="p=>{form.containerLockArray = p}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.baf" no="baf" :disabled="!isEdit" @change="uncheckClearValue(form.baf, 'bafArray')" />
                <span class="label-span">BAF</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  filterable
                  no="bafArray"
                  :disabled="!(isEdit && form.baf)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :clearable="true"
                  :default-multiple-value="form.bafArray"
                  :multiple="true"
                  callback-method-type="value"
                  style="width: 350px;"
                  tag-value="itemId"
                  tag-name="zhName"
                  :custom-label="(item)=>`[${item.chargecode}]${isZh ? item.zhName : item.enName}`"
                  @parentCallBack="p=>{form.bafArray = p}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.caf" no="caf" :disabled="!isEdit" @change="uncheckClearValue(form.caf, 'cafArray')" />
                <span class="label-span">CAF</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  filterable
                  no="cafArray"
                  :disabled="!(isEdit && form.caf)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :clearable="true"
                  :default-multiple-value="form.cafArray"
                  :multiple="true"
                  callback-method-type="value"
                  style="width: 350px;"
                  tag-value="itemId"
                  tag-name="zhName"
                  :custom-label="(item)=>`[${item.chargecode}]${isZh ? item.zhName : item.enName}`"
                  @parentCallBack="p=>{form.cafArray = p}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.otherCharge" no="otherCharge" :disabled="!isEdit" @change="uncheckClearValue(form.otherCharge, 'otherChargeArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_OtherAdditionalCharges') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  filterable
                  no="otherChargeArray"
                  :disabled="!(isEdit && form.otherCharge)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :clearable="true"
                  :default-multiple-value="form.otherChargeArray"
                  :multiple="true"
                  callback-method-type="value"
                  style="width: 350px;"
                  tag-value="itemId"
                  tag-name="zhName"
                  :custom-label="(item)=>`[${item.chargecode}]${isZh ? item.zhName : item.enName}`"
                  @parentCallBack="p=>{form.otherChargeArray = p}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.othc" no="othc" :disabled="!isEdit" @change="uncheckClearValue(form.othc, 'othcArray')" />
                <span class="label-span">O.THC</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  filterable
                  no="othcArray"
                  :disabled="!(isEdit && form.othc)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :clearable="true"
                  :default-multiple-value="form.othcArray"
                  :multiple="true"
                  callback-method-type="value"
                  style="width: 350px;"
                  tag-value="itemId"
                  tag-name="zhName"
                  :custom-label="(item)=>`[${item.chargecode}]${isZh ? item.zhName : item.enName}`"
                  @parentCallBack="p=>{form.othcArray = p}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.dthc" no="dthc" :disabled="!isEdit" @change="uncheckClearValue(form.dthc, 'dthcArray')" />
                <span class="label-span">D.THC</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  filterable
                  no="dthcArray"
                  :disabled="!(isEdit && form.dthc)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :clearable="true"
                  :default-multiple-value="form.dthcArray"
                  :multiple="true"
                  callback-method-type="value"
                  style="width: 350px;"
                  tag-value="itemId"
                  tag-name="zhName"
                  :custom-label="(item)=>`[${item.chargecode}]${isZh ? item.zhName : item.enName}`"
                  @parentCallBack="p=>{form.dthcArray = p}"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import lodash from 'lodash'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { EQ_SIZES } from '@/class/cargo/model/parameters/EQSize'
import { getDeclarationByAviationExchangePrice } from '@/api/sysManage/aviationExchangePrice'
import { TabError } from '@/utils/class/TabError'

export default {
  name: 'TabDeclarationScope',
  components: {
    AutoNumberInput,
    CargoAdvanceSelect
  },
  props: {
    isEdit: { type: Boolean, default: false, required: true },
    useHqSet: { type: Boolean, default: false, required: true },
    branchId: { type: Number, default: 0, required: true }
  },
  data() {
    return {
      SystemConstants,
      loading: false,
      isZh: this.$store.getters.language === 'zh',
      selectTypeNames: TYPE_NAMES,
      form: {},
      financeSetting: [],
      incoTermList: [],
      eqSizeType: [],
      pods: [{ code: this.$t('CargoMsg.Cargo_BasePort'), value: 'basic' }, { code: this.$t('CargoMsg.Cargo_All') + this.$t('CargoMsg.Cargo_Port'), value: 'all' }],
      numOperators: ['+', '-', '*', '/']
    }
  },
  computed: {},
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      const eqSizes = EQ_SIZES
      const eqTypes = await getSpecificBasicData(basicCacheKeys.basic_data_EQType)
      if (eqTypes && eqTypes.length > 0) {
        for (const eqType of eqTypes) {
          for (const eqSize of eqSizes) {
            const data = {
              code: eqSize.code + eqType.code,
              value: eqSize.code + eqType.code
            }
            this.eqSizeType.push(data)
          }
        }
      }
    },
    initForm() {
      this.form = {
        aviationExchangePriceUuid: '',
        fcl: false,
        fclArray: [],
        selfPickup: false,
        selfPickupArray: [],
        designatedGoods: false,
        designatedGoodsArray: [],
        pol: false,
        loadingPortCodeArray: [],
        pod: false,
        dischargingPortCodeArray: [],
        customJob: false,
        customJobTypeArray: [],
        cargoType: false,
        cargoTypeArray: [],
        price: true,
        priceArray: [],
        commission: false,
        commissionArray: [],
        containerLock: false,
        containerLockArray: [],
        baf: false,
        bafArray: [],
        caf: false,
        cafArray: [],
        otherCharge: false,
        otherChargeArray: [],
        othc: false,
        othcArray: [],
        dthc: false,
        dthcArray: [],
        lowerOperators: '*',
        lowerNum: 0,
        upperOperators: '*',
        upperNum: 0
      }
    },
    async onShow(data, isRefresh) {
      console.log('isRefresh ', isRefresh)
      if (isRefresh) {
        if (!data || !data.uuid) {
          this.initForm()
          return
        }
        const filter = {
          aviationExchangePriceUuid: data.uuid
        }
        await this.toQuery(filter)
      }
    },
    async toQuery(filter) {
      await getDeclarationByAviationExchangePrice(filter).then(res => {
        if (res.data) {
          this.form = res.data
          // 数据转换一下
          this.strConvertArrayData()
        } else {
          this.initForm()
        }
      })
    },
    uncheckClearValue(checked, fieldName) {
      if (!checked) {
        this.form[fieldName] = []
      }
    },
    async getSubmitData() {
      await this.validateForm()
      const data = lodash.cloneDeep(this.form)
      this.arrayConvertStrData(data)
      return {
        aviationExchangePriceDeclaration: data
      }
    },
    async validateForm() {
      if (this.useHqSet) { // 如果是总部设置，则不需要验证
        return true
      }
      if (this.form.fcl && (!this.form.fclArray || this.form.fclArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_FCL') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.selfPickup && (!this.form.selfPickupArray || this.form.selfPickupArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_CustomerSpace3') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.designatedGoods && (!this.form.designatedGoodsArray || this.form.designatedGoodsArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_CustomerSpace2') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.pol && (!this.form.loadingPortCodeArray || this.form.loadingPortCodeArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_PortOfLoading') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.pod && (!this.form.dischargingPortCodeArray || this.form.dischargingPortCodeArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_PortOfDischarge') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.customJob && (!this.form.customJobTypeArray || this.form.customJobTypeArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_CustomJobType') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.cargoType && (!this.form.cargoTypeArray || this.form.cargoTypeArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_CargoType') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.price) {
        if (!this.form.priceArray || this.form.priceArray.length === 0) {
          throw new TabError(this.$t('CargoMsg.Cargo_FreightRate') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
        }
        if (!this.form.lowerOperators || (this.form.lowerNum !== 0 && !this.form.lowerNum) || !this.form.upperOperators || (this.form.upperNum !== 0 && !this.form.upperNum)) {
          throw new TabError(this.$t('CargoMsg.Cargo_LowerLimit') + this.$t('CargoMsg.Cargo_UpperLimit') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
        }
      }
      if (this.form.commission && (!this.form.commissionArray || this.form.commissionArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_Commission') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.containerLock && (!this.form.containerLockArray || this.form.containerLockArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_ContainerLock') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.baf && (!this.form.bafArray || this.form.bafArray.length === 0)) {
        throw new TabError('BAF' + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.caf && (!this.form.cafArray || this.form.cafArray.length === 0)) {
        throw new TabError('CAF' + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.otherCharge && (!this.form.otherChargeArray || this.form.otherChargeArray.length === 0)) {
        throw new TabError(this.$t('CargoMsg.Cargo_OtherAdditionalCharges') + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.othc && (!this.form.othcArray || this.form.othcArray.length === 0)) {
        throw new TabError('O.THC' + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
      if (this.form.dthc && (!this.form.dthcArray || this.form.dthcArray.length === 0)) {
        throw new TabError('D.THC' + this.$t('queryJob.CannotBeEmpty'), 'tabDeclarationScope')
      }
    },
    arrayConvertStrData(data) {
      data.fclValue = this.arrayConvertToStr(this.form.fclArray)
      data.selfPickupValue = this.arrayConvertToStr(this.form.selfPickupArray)
      data.designatedGoodsValue = this.arrayConvertToStr(this.form.designatedGoodsArray)
      data.loadingPortCode = this.arrayConvertToStr(this.form.loadingPortCodeArray)
      data.dischargingPortCode = this.arrayConvertToStr(this.form.dischargingPortCodeArray)
      data.customJobType = this.arrayConvertToStr(this.form.customJobTypeArray)
      data.cargoTypeValue = this.arrayConvertToStr(this.form.cargoTypeArray)
      data.priceValue = this.arrayConvertToStr(this.form.priceArray)
      data.commissionValue = this.arrayConvertToStr(this.form.commissionArray)
      data.containerLockValue = this.arrayConvertToStr(this.form.containerLockArray)
      data.bafValue = this.arrayConvertToStr(this.form.bafArray)
      data.cafValue = this.arrayConvertToStr(this.form.cafArray)
      data.otherChargeValue = this.arrayConvertToStr(this.form.otherChargeArray)
      data.othcValue = this.arrayConvertToStr(this.form.othcArray)
      data.dthcValue = this.arrayConvertToStr(this.form.dthcArray)
    },
    strConvertArrayData() {
      this.form.fclArray = this.strConvertToArray(this.form.fclValue)
      this.form.selfPickupArray = this.strConvertToArray(this.form.selfPickupValue)
      this.form.designatedGoodsArray = this.strConvertToArray(this.form.designatedGoodsValue)
      this.form.loadingPortCodeArray = this.strConvertToArray(this.form.loadingPortCode)
      this.form.dischargingPortCodeArray = this.strConvertToArray(this.form.dischargingPortCode)
      this.form.customJobTypeArray = this.strConvertToArray(this.form.customJobType)
      this.form.cargoTypeArray = this.strConvertToArray(this.form.cargoTypeValue)
      this.form.priceArray = this.strConvertToArray(this.form.priceValue, true)
      this.form.commissionArray = this.strConvertToArray(this.form.commissionValue, true)
      this.form.containerLockArray = this.strConvertToArray(this.form.containerLockValue, true)
      this.form.bafArray = this.strConvertToArray(this.form.bafValue, true)
      this.form.cafArray = this.strConvertToArray(this.form.cafValue, true)
      this.form.otherChargeArray = this.strConvertToArray(this.form.otherChargeValue, true)
      this.form.othcArray = this.strConvertToArray(this.form.othcValue, true)
      this.form.dthcArray = this.strConvertToArray(this.form.dthcValue, true)
    },
    // 将逗号分隔的字符串转换为数组
    strConvertToArray(str, isNumber = false) {
      if (str && str.length > 0) {
        const array = str.split(',')
        if (isNumber) {
          return array.map(Number)
        }
        return array
      }
      return []
    },
    // 将数组转换为逗号分隔的字符串
    arrayConvertToStr(arrys) {
      if (arrys && arrys.length > 0) {
        return arrys.join(',')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.declaration-scope{
  .title{
    display: inline-block;
    position: relative;
    font-size: 18px;
    padding-left: 15px;
    margin-bottom: 10px;
  }
  .title:before {
    content: '';
    position: absolute;
    width: 4px;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: #1F75D5;
  }
  .el-form-item-wrapper .form-item{
    width: 130px;
  }
  .el-form-item-wrapper .label-span{
    margin-left: 10px;
  }
  /deep/ .el-input-number__increase,
  /deep/ .el-input-number__decrease {
    width: 15px !important; /* 你可以根据需要调整宽度 */
    min-width: 15px !important;
    padding: 0;
  }
}
</style>
